import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Input,
  message,
  Select,
  Radio,
  Checkbox,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import AppConfigs from "../Config/AppConfig";
import { add, list } from "../api/Apis";

const { Option } = Select;

class PushToCarrier extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: this.props?.show,
      rateErrorMsg: "",
      masterData: [],
      callForRateValue: this.props?.leadData["callForRate"],
    };
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount = () => {
    this.getCategoriesAndSubCategories(
      "carrierTag",
      "subCategoriesDataLoading"
    );
  };

  getCategoriesAndSubCategories = (dataType, loadingVariable) => {
    let query = {
      dataType: dataType,
      recordStatus: true,
    };
    list(AppConfigs["entityNames"]["masterData"], query).then((result) => {
      if (result.success) {
        let masterData = result.data;
        this.setState({
          masterData: masterData,
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoading: false,
        });
      }
    });
  };

  showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false, loading: false });
    window.location.reload();
    this.props.form.resetFields();
    this.props.hideModal();
  };

  pushToCarriers = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["callForRate", "rateValue", "rateOption", "tags"],
      async (err, values) => {
        if (!err) {
          this.setState({
            loading: false,
          });
          let rateValue = null,
            rateAmt = null,
            rateOption = null,
            callForRate = false;
          if ("callForRate" in values || this.props.leadData["rateValue"]) {
            if (
              (values["rateValue"] === "" ||
                !values["rateValue"] ||
                !values["rateOption"]) &&
              !values["callForRate"]
            ) {
              this.setState({
                rateErrorMsg:
                  "Please enter rate value and rate option or check the call for rate!",
              });
              message.error(
                "Please enter rate value and rate option and or check the call for rate!"
              );
              return;
            }
            if (!values["callForRate"]) {
              rateAmt = values["rateValue"];
              rateOption = values["rateOption"];
              rateValue =
                values["rateOption"] === "ton"
                  ? parseFloat(values["rateValue"]) *
                    parseInt(this.props.leadData["cartItems"][0]["quantity"])
                  : values["rateValue"];
            }
            callForRate = values["callForRate"];
          } else {
            rateValue = this.props.leadData["rateValue"];
            rateAmt = this.props.leadData["rateAmt"];
            rateOption = this.props.leadData["rateOption"];
            callForRate = this.props.leadData["callForRate"];
          }
          if (!values["tags"]) {
            values["tags"] = [];
          }
          let data = {
            entityData: {
              leadId: this.props.leadData["id"],
              orderStatus: AppConfigs["PUSH_TO_CARRIER"],
              rateValue: rateValue,
              rateAmt: rateAmt,
              rateOption: rateOption,
              tags: values["tags"],
              callForRate: callForRate ? callForRate : false,
              // recordId: this.props.leadData.id,
              // typeofPage: "orderDetails"
            },
          };
          add(AppConfigs["pushToCarrier"], data).then((result) => {
            if (result.success) {
              message.success("Load pushed to carrier successfully");
              if (this.props.callFrom === "orders") {
                this.hideModal();
                this.props.getOrders();
              } else {
                window.location.reload();
              }
            } else {
              console.log(result.errors);
              window.location.reload();
            }
            this.props.form.resetFields();
          });
          this.setState({
            loading: true,
          });
        }
      }
    );
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    let leadData = this.props.leadData;
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
    };
    return (
      <main>
        {/* {this.props.callFrom === "orders" ? (
          <span
            style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
            onClick={() => {
              this.showModal();
            }}
          >
            Push to Carriers
          </span>
        ) : (
          <h3 style={{ color: "#fff" }}>
            <Button
              style={{
                background: "#0e4d90",
                borderColor: "#FFF",
                color: "#FFF",
              }}
              onClick={() => {
                this.showModal();
              }}
            >
              Push to Carrier
            </Button>
          </h3>
        )} */}
        <Form>
          <Modal
            visible={this.state.show}
            closable={true}
            footer={[
              <Button
                key="cancel"
                className="cancel"
                onClick={() => {
                  this.hideModal();
                }}
              >
                Cancel
              </Button>,
              <Button
                type="primary"
                key="editSubmit"
                htmlType="submit"
                loading={this.state.loading}
                onClick={this.pushToCarriers}
              >
                Push To Carrier
              </Button>,
            ]}
          >
            <div>
              <Row>
                <CloseOutlined
                  onClick={() => {
                    this.hideModal();
                  }}
                  style={{
                    float: "right",
                    cursor: "pointer",
                    fontSize: "1.4em",
                  }}
                />

                {/* {leadData["rateValue"] && leadData["callForRate"] && ( */}
                {!leadData["rateValue"] && (
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      label={
                        <span style={{ color: "#7B8190" }}>
                          What's the Rate?
                        </span>
                      }
                    >
                      {getFieldDecorator("callForRate", {
                        initialValue:this.state.callForRateValue,
                      })(
                        <Checkbox
                          checked={this.state.callForRateValue}
                          style={{}}
                          onChange={() => {
                            this.setState({
                              callForRateValue: !this.state.callForRateValue,
                            });
                          }}
                        >
                          Call for Rate
                        </Checkbox>
                      )}
                    </Form.Item>
                  </Col>
                )}
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item>
                    {getFieldDecorator("rateValue", {
                      initialValue: leadData["rateAmt"],
                    })(
                      <Input
                        placeholder="Rate"
                        disabled={getFieldValue("callForRate")}
                        addonBefore="$"
                        style={{ width: "95%" }}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item className="Formitem">
                    {getFieldDecorator("rateOption", {
                      initialValue: leadData["rateOption"],
                    })(
                      <Radio.Group disabled={getFieldValue("callForRate")}>
                        <Radio style={radioStyle} value={"ton"}>
                          Ton
                        </Radio>
                        <Radio style={radioStyle} value={"flat"}>
                          Flat Rate
                        </Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                  <span style={{ color: "red" }}>
                    {this.state.rateErrorMsg}
                  </span>
                </Col>

                {/* )} */}
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={
                      <span style={{ color: "black" }}>Select the Tags</span>
                    }
                  >
                    {getFieldDecorator(
                      "tags",
                      { initialValue: leadData["tags"] },
                      {
                        rules: [{ type: "array" }],
                      }
                    )(
                      <Select
                        mode="multiple"
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Please Select"
                        showArrow
                      >
                        {this.state.masterData
                          .sort((a, b) => (a["name"] > b["name"] ? 1 : -1))
                          .map((tag) => (
                            <Option value={tag.id} key={tag.id}>
                              {tag.name}
                            </Option>
                          ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Modal>
        </Form>
      </main>
    );
  }
}

export default Form.create({ name: "PushToCarrier" })(PushToCarrier);
